export default {
  save: 'Save',
  delete: 'Delete',
  'save-as': 'Save as',
  update: 'Edit',
  cancel: 'Cancel',
  previous: 'Previous',
  next: 'Next',
  about: 'About',
  advanced: 'Advanced',
  link: 'Link',
  thumbnail: 'Thumbnail',
  badges: 'Badges',
  avatar: 'Avatar',

  name: 'Name',
  resume: 'Resume',
  description: 'Description',
  period: 'Period',
  events: 'Events',
  score: 'Score',
  success: 'Success sentence',

  activities: 'Activity thread',
  gamifications: 'Gamifications',
  messages: 'Messages',
  friends: 'Friends',

  timeframe: {
    noperiod: 'No period',
    morning: 'the morning',
    midday: 'the midday',
    afternoon: 'the afternoon',
    evening: 'the evening',
    day: 'all day',
    night: 'the night',
    monday: 'on monday',
    tuesday: 'on tuesday',
    wednesday: 'on wednesday',
    thursday: 'on thursday',
    friday: 'on friday',
    saturday: 'on saturday',
    sunday: 'on sunday',
    weekend: 'on weekend'
  },

  sentencestart: 'Popup launch sentence',
  sentencedead: 'Popup finish sentence',
  sentencesurvive: 'Popup failed sentence'
}



// WEBPACK FOOTER //
// ./src/translations/en/common.js